
<template>
    <div class="diagram-container">
      <div class="branch">
        <div class="node-wrapper">
          <div class="node" @click="showNodeInfo(node)" :style="{ backgroundColor: node.color || '#fff' }">
            {{ node.name }}
          </div>
          <div class="node-actions">
            <v-btn small class="small-btn" color="white" @click="addChild(node)">
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
            <v-btn small class="small-btn" color="red" @click="deleteNode(node)">
              <v-icon small>mdi-minus</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="children" v-if="node.children.length">
          <BracketDiagram
            v-for="(child, index) in node.children"
            :key="index"
            :node="child"
            @showNodeInfo="showNodeInfo"
            @addChild="addChild"
            @deleteNode="deleteNode"
          />
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'BracketDiagram',
  props: {
    node: Object
  },
  methods: {
    showNodeInfo (node) {
      this.$emit('showNodeInfo', node)
    },
    addChild (node) {
      const newNode = {
        name: `Child of ${node.name}`,
        color: this.getRandomColor(),
        children: []
      }
      this.$emit('addChild', node, newNode)
    },
    deleteNode (node) {
      this.$emit('deleteNode', node)
    },
    getRandomColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    }
  }
}
</script>

<style scoped>
template {
  overflow-x: auto; /* Permitir desplazamiento horizontal en toda la página */
  white-space: nowrap; /* Evitar el ajuste de línea en el contenido */
  width: 100%;
}

.diagram-container {
  display: flex; /* Permitir que los elementos internos se alineen en línea */
}

.branch {
  display: inline-flex; /* Usar inline-flex para alinear en línea */
  flex-direction: column;
  align-items: center;
  margin: 3px;
}

.node-wrapper {
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.node {
  background-color: #e0e0e0;
  border-radius: 3px;
  padding: 3px;
  cursor: pointer;
  text-align: center;
  min-width: 50px;
  font-size: 12px;
}

.node-actions {
  display: flex;
  gap: 10px;
  margin-top: 2px;
}

.small-btn {
  max-height: 17px;
  padding: 1px 1px 1px 1px !important;
  min-width: 1px !important;
}

.children {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>
